<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Date Range</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                          <cal-picker
                            v-model="reportForm.uwTranDateFrom"
                            :label="labels.uwTranDateFrom"
                            v-validate="'required'"
                            :data-vv-as="labels.uwTranDateFrom"
                            data-vv-name="uwTranDateFrom"
                            :error-messages="errors.collect('uwTranDateFrom')"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 md6>
                          <cal-picker
                            v-model="reportForm.uwTranDateTo"
                            :label="labels.uwTranDateTo"
                            v-validate="toDateValidation1(reportForm.uwTranDateFrom)"
                            :data-vv-as="labels.uwTranDateTo"
                            data-vv-name="uwTranDateTo"
                            :error-messages="errors.collect('uwTranDateTo')"
                            :min="this.reportForm.uwTransDateFrom"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 md6>
                          <cal-picker
                            v-model="reportForm.ytdClmTranDateFrom"
                            :label="labels.ytdClmTranDateFrom"
                            v-validate="'required'"
                            :data-vv-as="labels.ytdClmTranDateFrom"
                            data-vv-name="ytdClmTranDateFrom"
                            :error-messages="errors.collect('ytdClmTranDateFrom')"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 md6>
                          <cal-picker
                            v-model="reportForm.ytdClmTranDateTo"
                            :label="labels.ytdClmTranDateTo"
                            v-validate="toDateValidation2(reportForm.ytdClmTranDateFrom)"
                            :data-vv-as="labels.ytdClmTranDateTo"
                            data-vv-name="ytdClmTranDateTo"
                            :error-messages="errors.collect('ytdClmTranDateTo')"
                            :min="this.reportForm.ytdClmTranDateTo"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 md6>
                          <cal-picker
                            v-model="reportForm.lastYrOSClmAsAtDate"
                            :label="labels.lastYrOSClmAsAtDate"
                            v-validate="'required'"
                            :data-vv-as="labels.lastYrOSClmAsAtDate"
                            data-vv-name="lastYrOSClmAsAtDate"
                            :error-messages="errors.collect('lastYrOSClmAsAtDate')"
                            :min="this.reportForm.lastYrOSClmAsAtDate"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-text-field
                            v-model="reportForm.inter"
                            :label="labels.inter"
                            :error-messages="errors.collect('inter')"
                            data-vv-name="inter"
                            :data-vv-as="labels.inter"
                            append-icon="mdi-magnify"
                            @click:append="interHelpList = true"
                            v-validate="'required'"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
              </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            :label="labels.pbPrtParam"
            v-model="reportForm.pbPrtParam"
            :error-messages="errors.collect('pbPrtParam')"
            data-vv-name="pbPrtParam"
            :data-vv-as="labels.pbPrtParam"
          />
        </v-flex>
        <v-flex xs12>
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="reportForm.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
      <v-dialog v-model="interHelpList" width="900px" persistent>
        <multi-intermediary-help-list
          :intr="reportForm.inter"
          helpListTitle="Billing Account No. Helplist"
          @close="interHelpList = false"
          @doAssign="doAssign($event)"
        ></multi-intermediary-help-list>
      </v-dialog>
    </v-container>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import MultiIntermediaryHelpList from '@/components/reports/underwriting/helplist/MultiIntermediaryHelpList.vue'

export default {
  data() {
    return {
      labels: {
        uwTranDateFrom: 'Underwriting Transaction Date From*',
        uwTranDateTo: 'Underwriting Transaction Date To*',
        ytdClmTranDateFrom: 'YTD Claim Transaction Date From*',
        ytdClmTranDateTo: 'YTD Claim Transaction Date To*',
        lastYrOSClmAsAtDate: 'Last Year O/S Claim As At Date*',
        inter: 'Billing Account(s)',
        format: 'Export Format',
        export: 'Export to',
        pbPrtParam: 'Print Runtime Parameters'
      },
      reportForm: {
        uwTranDateFrom: null,
        uwTranDateTo: null,
        ytdClmTranDateFrom: null,
        ytdClmTranDateTo: null,
        lastYrOSClmAsAtDate: null,
        inter: 'All',
        format: 'PDF',
        pbPrtParam: true
      },
      menu: {},
      supportedFormat: [],
      interHelpList: false,
      submitting: false,
      rptHistory: false,
      panel: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.init !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initStatsByBusGrp
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    toDateValidation1(fromDate) {
      const result = 'required|from_to_date:' + fromDate
      return result
    },
    toDateValidation2(fromDate) {
      const result = 'required|from_to_date:' + fromDate
      return result
    },
    doAssign(data) {
      if (this.interHelpList) {
        this.reportForm.inter = []
        this.reportForm.inter = data.finalSelectedItems.toString()
      }
      this.interHelpList = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportStatsByBusGrp
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [MessageMixin],
  components: {
    MultiIntermediaryHelpList
  }
}
</script>
